import { useCifraClient } from '@/api/cifra-client';

const { cifraClient } = useCifraClient();

const BASE = '/api/v2/seleccion_destinatarios';

function extraerDatos(respuesta) {
  return respuesta.data?.data ?? respuesta.data;
}

export default {
  tiposBusqueda() {
    return cifraClient.get(`${BASE}/tipos_busqueda`).then(extraerDatos);
  },

  listaRoles() {
    return cifraClient.get(`${BASE}/lista_roles`).then(extraerDatos);
  },

  listaGruposContacto() {
    return cifraClient.get(`${BASE}/lista_grupos_contacto`).then(extraerDatos);
  },

  listaDirecciones() {
    return cifraClient.get(`${BASE}/lista_direcciones`).then(extraerDatos);
  },

  tiposDestinatarios(params) {
    return cifraClient.post(`${BASE}/tipos_destinatarios`, params).then(extraerDatos);
  },

  buscarDestinatarios(params) {
    return cifraClient.post(`${BASE}/buscar_destinatarios`, params).then(extraerDatos);
  },

  destinatariosReales(params) {
    return cifraClient.post(`${BASE}/destinatarios_reales`, {
      ...params,
      formato_web: true,
    }).then(extraerDatos);
  },
};
